import { render, staticRenderFns } from "./PageFaq.vue?vue&type=template&id=04b27aeb"
import script from "./PageFaq.vue?vue&type=script&lang=js"
export * from "./PageFaq.vue?vue&type=script&lang=js"
import style0 from "./PageFaq.vue?vue&type=style&index=0&id=04b27aeb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports